import angular from "angular";
import AdminServiceAreasController from "./admin-service-area.controller";
import ResetSchoolServiceAreaModalController from "./reset-school-service-area-modal/reset-school-service-area-modal.controller";
import template from "./admin-service-area.html";
import ServiceAreaMap from "../directives/service-area-editor/ServiceAreaMap.vue";
import ZonePartsList from "../directives/service-area-editor/ZonePartsList.vue";

// Import Vue components for ngVue registration

export default angular
  .module("drivecoach.admin.serviceArea", ["ui.router", "ngVue"])
  .config([
    "$stateProvider",
    "USER_ROLES",
    function ($stateProvider, USER_ROLES) {
      $stateProvider.state("drivecoach.admin.serviceArea", {
        url: "/:schoolId/service-area",
        template: template,
        controller: "AdminServiceAreaController",
        controllerAs: "vm",
        data: {
          authorizedRoles: [
            USER_ROLES.admin,
            USER_ROLES.administrator,
            USER_ROLES.owner,
          ],
        },
      });
    },
  ])
  .controller("AdminServiceAreaController", AdminServiceAreasController)
  .controller(
    "ResetSchoolServiceAreaModalController",
    ResetSchoolServiceAreaModalController,
  )
  // Register Vue components
  .directive("serviceAreaMap", [
    "createVueComponent",
    function (createVueComponent) {
      return createVueComponent(ServiceAreaMap, {
        props: {
          schoolId: "=",
          height: "@",
          width: "@",
          showLegend: "=",
          onSave: "&",
          onError: "&",
        },
      });
    },
  ])
  .directive("zonePartsList", [
    "createVueComponent",
    function (createVueComponent) {
      return createVueComponent(ZonePartsList, {
        props: {
          schoolId: "=",
          onFeatureSelect: "&",
        },
      });
    },
  ]);
